import React, { Component } from "react";
import { Grid, Typography, Button, Paper } from '@material-ui/core';
import Job from '../job/job';
import AddBoxIcon from '@material-ui/icons/AddBox';

import "./management-job-list.css";

export default class ManagementJobList extends Component {

render() {   
    return (<Paper elevation={1} component="div" className="management-job-list-container">
                <Grid 
                    container
                    justify="space-between">
                    <Grid item xs="auto">
                        <Typography variant="h6" gutterBottom>{this.props.engineer.fullName}</Typography>        
                    </Grid>
                    {/* <Grid item xs="auto">
                        <Typography variant="h6" gutterBottom>{this.props.engineer.progress}%</Typography>  
                    </Grid>     */}
                </Grid>
                <Button color="primary" onClick={() => this.props.addJob(this.props.engineer)} startIcon={<AddBoxIcon />} size="large">Add Job</Button>
                {this.props.jobs.map((job, jobIndex) => {
                    return <Job
                    job={job}
                    key={"engineer_" + this.props.engineerIndex + "_job" + jobIndex}
                    onJobClick={() => this.props.editJob(job, this.props.engineer)}
                    onDeleteJob={() => this.props.deleteJob(job)} />
                })}
            </Paper>);
    }
}